import {useNavigate} from 'react-router-dom';

const Header = ({title}: IMainHeaderProps) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="sticky top-0 z-10 flex justify-between bg-white w-full px-4 py-6">
        <span
          className="icon-arrow_left text-2xl"
          onClick={() => navigate(-1)}
        ></span>
        <p>{title}</p>
        <div></div>
      </div>
    </>
  );
};

export default Header;
